import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import {
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { useSelector } from "react-redux";
import {
  AreaChartOutlined,
  ScheduleOutlined,
  SolutionOutlined,
} from "@ant-design/icons";

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

const SidebarContent = () => {
  let { navStyle, themeType, pathname } = useSelector(
    ({ settings }) => settings
  );

  const getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };
  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];
  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
            mode="inline"
          >
            <MenuItemGroup className="gx-menu-group">
              <SubMenu
                key="user"
                className={getNavStyleSubMenuClass(navStyle)}
                title={
                  <span>
                    {" "}
                    <i className="icon icon-user" />
                    <span>
                      <IntlMessages id="Database" />
                    </span>
                  </span>
                }
              >
                <Menu.Item key="/database/view">
                  <Link to="/database/view">
                    <span>
                      <IntlMessages id="View" />
                    </span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="/database/add">
                  <Link to="/database/add">
                    <span>
                      <IntlMessages id="Add" />
                    </span>
                  </Link>
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="attendance"
                className={getNavStyleSubMenuClass(navStyle)}
                title={
                  <span>
                    {" "}
                    <SolutionOutlined />
                    <span style={{ marginLeft: 0 }}>
                      <IntlMessages id="Attendance" />
                    </span>
                  </span>
                }
              >
                <Menu.Item key="/attendance/view">
                  <Link to="/attendance/view">
                    <span>
                      <IntlMessages id="View" />
                    </span>
                  </Link>
                </Menu.Item>
                <Menu.Item key="/attendance/add">
                  <Link to="/attendance/add">
                    <span>
                      <IntlMessages id="Add" />
                    </span>
                  </Link>
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="report"
                className={getNavStyleSubMenuClass(navStyle)}
                title={
                  <span>
                    {" "}
                    <AreaChartOutlined />
                    <span style={{ marginLeft: 0 }}>
                      <IntlMessages id="Report" />
                    </span>
                  </span>
                }
              >
                <Menu.Item key="/report/view">
                  <Link to="/report/view">
                    <span>
                      <IntlMessages id="View" />
                    </span>
                  </Link>
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="events"
                className={getNavStyleSubMenuClass(navStyle)}
                title={
                  <span>
                    {" "}
                    <ScheduleOutlined />
                    <span style={{ marginLeft: 0 }}>
                      <IntlMessages id="Events" />
                    </span>
                  </span>
                }
              >
                <Menu.Item key="/event/view">
                  <Link to="/event/view">
                    <span>
                      <IntlMessages id="View" />
                    </span>
                  </Link>
                </Menu.Item>
              </SubMenu>
            </MenuItemGroup>
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

SidebarContent.propTypes = {};
export default SidebarContent;
